// ============================================
// Enums (mirror DB enums + system-category keys)
// ============================================
export var ExpenseStatus;
(function (ExpenseStatus) {
    ExpenseStatus["PENDING"] = "PENDING";
    ExpenseStatus["PAID"] = "PAID";
    ExpenseStatus["CANCELLED"] = "CANCELLED";
})(ExpenseStatus || (ExpenseStatus = {}));
export var ExpensePaymentMethod;
(function (ExpensePaymentMethod) {
    ExpensePaymentMethod["CASH"] = "CASH";
    ExpensePaymentMethod["BANK_TRANSFER"] = "BANK_TRANSFER";
    ExpensePaymentMethod["CARD"] = "CARD";
    ExpensePaymentMethod["PIX"] = "PIX";
    ExpensePaymentMethod["OTHER"] = "OTHER";
})(ExpensePaymentMethod || (ExpensePaymentMethod = {}));
export var RecurringFrequency;
(function (RecurringFrequency) {
    RecurringFrequency["WEEKLY"] = "WEEKLY";
    RecurringFrequency["MONTHLY"] = "MONTHLY";
    RecurringFrequency["YEARLY"] = "YEARLY";
})(RecurringFrequency || (RecurringFrequency = {}));
export var ExpenseCategorySystemKey;
(function (ExpenseCategorySystemKey) {
    ExpenseCategorySystemKey["RENT_UTILITIES"] = "RENT_UTILITIES";
    ExpenseCategorySystemKey["PAYROLL"] = "PAYROLL";
    ExpenseCategorySystemKey["EQUIPMENT"] = "EQUIPMENT";
    ExpenseCategorySystemKey["MARKETING"] = "MARKETING";
    ExpenseCategorySystemKey["SOFTWARE"] = "SOFTWARE";
    ExpenseCategorySystemKey["TAXES_FEES"] = "TAXES_FEES";
    ExpenseCategorySystemKey["SUPPLIES"] = "SUPPLIES";
    ExpenseCategorySystemKey["OTHER"] = "OTHER";
})(ExpenseCategorySystemKey || (ExpenseCategorySystemKey = {}));
export const EXPENSE_CATEGORY_SYSTEM_KEYS = [
    ExpenseCategorySystemKey.RENT_UTILITIES,
    ExpenseCategorySystemKey.PAYROLL,
    ExpenseCategorySystemKey.EQUIPMENT,
    ExpenseCategorySystemKey.MARKETING,
    ExpenseCategorySystemKey.SOFTWARE,
    ExpenseCategorySystemKey.TAXES_FEES,
    ExpenseCategorySystemKey.SUPPLIES,
    ExpenseCategorySystemKey.OTHER,
];
//# sourceMappingURL=OrgMgmtCostManagement.js.map